/**
 * API Configuration - Smart Backend URL Resolution
 * 
 * CRITICAL FIX: For custom domains (like app.jyotishpuraan.com), we MUST
 * use window.location.origin, NOT the build-time REACT_APP_BACKEND_URL.
 * 
 * The REACT_APP_BACKEND_URL contains the Emergent preview URL which is
 * different from the production custom domain, causing CORS errors.
 */

// Get backend URL at RUNTIME - ALWAYS use same origin for deployed apps
export const getBackendUrl = () => {
  // ALWAYS check window.location.origin FIRST for browser environments
  // This ensures custom domains work correctly
  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
    const hostname = window.location.hostname;
    
    // Local development - use same origin (proxy handles routing)
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      console.log('🚀 [API Config] Local dev - using same origin:', origin);
      return origin;
    }
    
    // Custom domain (production) - ALWAYS use same origin
    // DO NOT use REACT_APP_BACKEND_URL here as it contains the preview URL
    // which causes CORS errors on custom domains
    console.log('🚀 [API Config] Custom domain - using same origin:', origin);
    return origin;
  }
  
  // SSR/build time fallback only - use env var
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  return '';
};

// Dynamic getter that always returns current URL (for runtime use)
export const getApiUrl = () => `${getBackendUrl()}/api`;

/**
 * DEPRECATED: These are kept for backward compatibility but should NOT be used.
 * Use getBackendUrl() or getApiUrl() inside your functions instead.
 */
export const BACKEND_URL = getBackendUrl();
export const API_URL = `${getBackendUrl()}/api`;

export default getBackendUrl;
